import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTransaction, updateTransaction ,  setPageSize , clearCache } from '../../slices/TransactionHistorySlice/TransactionSlice';
// import Pagination from '../../components/Pagination';
import EditableTable from './TransactionTable';
import Modal from '../../components/Modal';
import ChangeLog from '../../components/ChangeLog'; 
import Loader from "../../components/Loader";
import { fetchTransactionType } from '../../slices/TransactionHistorySlice/TransactionTypeSlice';
import { fetchAgencies } from '../../slices/RedeemSlice/AgencySlice';
import AddTransaction from './AddTransaction';

import SimplePagination from "@/components/SimplePagination";
import PanelUserSearch from "@/components/PanelUserSearch";
import PageSizeSelector from "@/components/PageSizeSelector";



const Transaction = () => {
  const dispatch = useDispatch();
  const { transactionList , currentPage, totalPages, status , search , pageSize } = useSelector((state) => state.transaction);
  const [editRowId, setEditRowId] = useState(null); // Track which row is in edit mode
  const [editedData, setEditedData] = useState({}); // Store temporary data for edited row

  const editableFields = ['failedTransaction','completeTransaction', 'point', 'title', 'status', 'transactionType', 'method', 'detail'];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [addModalDis, setAddModalDis] = useState(false);
    const [searchInput, setSearchInput] = useState(search || "");
  
  const transactionType = useSelector((state)=>state.transactionType)

  const agency= useSelector((state)=>state.agency)

  useEffect(() => {
      dispatch(fetchTransaction({ page: 1, search}));
    if(transactionType.status === 'idle'){
      dispatch(fetchTransactionType());
    }

    if(agency.status === 'idle'){
      dispatch(fetchAgencies());
    }
  }, [dispatch]);

   
  console.log(transactionList , "transactionList")
  
    // ✅ Debounced search (MAIN CONTROL)
      useEffect(() => {
        const timer = setTimeout(() => {
          dispatch(fetchTransaction({ page: 1, search: encodeURIComponent(searchInput) }));
        }, 800);
    
        return () => clearTimeout(timer);
      }, [searchInput]);
    
        // ✅ Page change
      useEffect(() => {
          dispatch(fetchTransaction({ page: currentPage, search :encodeURIComponent(searchInput) }));
      }, [currentPage]);
  
  
    // ✅ Page size change
    const handlePageSizeChange = (size) => {
      dispatch(setPageSize(size)); // update slice
      dispatch(fetchTransaction({ page: 1, search }));
    }; 
  

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = transactionList.result?.find((user) => user.id === rowId);
    setEditedData(rowData); // Pre-fill the fields with current row data
  };

  const handleSave = async () => {
    // Extract only id, point, and detail for the API call
    const { id,title,status,method,detail, point, completeTransaction, failedTransaction} = editedData;
    const transactionTypeId = transactionType.transactionTypeList.result.filter((f)=>f.title === editedData.transactionType)[0].id;

    const methodId = agency.agencyList.result.filter((f)=>f.agencyName === editedData.method)[0].id;

    const updatedData = {id,title,status,method:methodId,detail, point, completeTransaction, failedTransaction, transactionType:transactionTypeId};
    // console.log(updatedData)
    const resp = await dispatch(updateTransaction(updatedData));

    if(!resp.error){
      dispatch(fetchTransaction());
    }
    setEditRowId(null); // Exit edit mode after saving
  };

  const handleCancel = () => {
    setEditRowId(null); // Exit edit mode and reset data
    setEditedData({}); // Reset to original data
  };

  const handleLog = (id)=>{
    const logData = transactionList?.Change_Log?.filter((f)=> f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  const handleChange = (e, field,val) => {
    if(field==="active" || field==="status" || field==='is_read' || field==="failedTransaction" || field==="completeTransaction"){
      setEditedData((prev) => ({
        ...prev,
        [field]:!val,
      }));
    }else{
      setEditedData((prev) => ({
        ...prev,
        [field]:e.target.value,
      }));
    }
};

  const hasData = transactionList?.result?.length > 0;
  const isSearching = searchInput && searchInput.trim() !== "";


  const headers = transactionList.result?.length > 0 ? Object.keys(transactionList.result[0]).filter((key) => key !== 'id') : [];

   if (status === "loading") {
    return (
      <div className="w-full pt-20 flex justify-center">
        <Loader />
      </div>
    );
  }

  // if (status === 'failed') {
  //   return <div>Error: {error}</div>;
  // }

  if (!transactionList || transactionList.length === 0) {
    return <div>No data available</div>;
  }

  return (
    <div className="w-full flex items-center flex-col">
      <div className="max-w-[93%] overflow-scroll">

        <PanelUserSearch  
            value={searchInput}
           onChange={setSearchInput}
          />

        <div >
        {hasData ? (
          
          
      <EditableTable
        headers={headers}
        rows={transactionList?.result || []}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields}
        transactionTypeList={transactionType.transactionTypeList}
        agencyList={agency.agencyList}
        displayAction={false}
      />

         ) : (
    <div className="w-full flex flex-col items-center justify-center py-20 text-gray-500">

      {/* Icon */}
      <div className="text-5xl mb-3">🔍</div>

      {/* Message */}
      {searchInput ? (
        <>
          <p className="text-lg font-medium">No results found</p>
          <p className="text-sm mt-1">
            for "<span className="font-semibold">{searchInput}</span>"
          </p>
        </>
      ) : (
        <>
          <p className="text-lg font-medium">No Data Available</p>
          <p className="text-sm mt-1">
            There are no users to display
          </p>
        </>
      )}

    </div>
  )}
      </div>
    

 {!(isSearching && !hasData) && (
  <div className="flex mt-4 items-center justify-between ">
    <PageSizeSelector
      pageSize={pageSize}
      setPageSize={handlePageSizeChange}
    />

  <SimplePagination
    currentPage={currentPage}
    setCurrentPage={(page) =>
      dispatch(fetchTransaction({ page, search : encodeURIComponent(searchInput) }))
    }
    totalPages={totalPages}
  />

{/* <button className="activeBtn text-sm text-white  py-1 px-2 rounded" onClick={()=>setAddModalDis(true)}> Add Redeem List</button> */}

</div>
 )}


{/* <Modal
        isOpen={addModalDis}
        onClose={()=>setAddModalDis(false)}
        title="Add Redeem List"
        content={<AddTransaction/>}
/>  */}

<Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />
    </div>
    </div>
  );
};

export default Transaction;
